import { create } from 'zustand';

type DebugPopupState = {
  testPassedOpen: boolean;
  setTestPassedOpen: (open: boolean) => void;
};

export const useDebugPopupStore = create<DebugPopupState>((set) => ({
  testPassedOpen: false,
  setTestPassedOpen: (open) => set({ testPassedOpen: open }),
}));
